import Guarded from '@/components/Guarded';

import { Results } from './components/ResultsContents';

export default ResultsPage;

export const title = 'Results';

// Main component
function ResultsPage() {
  return (
    <Guarded>
      <Results userId="me" />
    </Guarded>
  );
}
